<template>
  <div id="List">
    <div class="columns is-variable is-0">
      <div class="column is-narrow">
        <div class="vehicles_top_box">CLIENTI</div>
        <VueScrollTable :options="options" :columns="columns" :rows="users" />
      </div>
      <div class="column">
        <div class="vehicles_top_box">
          Clienti attivi (&lt; 24h)[{{ loginLive.length }}]
          <div class="is-pulled-right">
            <span class="button is-info is-tiny" @click="doGetLive">Check</span>
          </div>
        </div>
        <VueScrollTable
          :options="optionsLogLive"
          :columns="columnsLogLive"
          :rows="loginLive"
        />
      </div>
      <div class="column">
        <div class="vehicles_top_box">
          Logs accessi ultimi 7 giorni
          <div class="is-pulled-right">
            <span class="button is-info is-tiny" @click="doGetLogs">Check</span>
          </div>
        </div>
        <VueScrollTable
          :options="optionsLogOld"
          :columns="columnsLogOld"
          :rows="logs"
        />
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import { ServiceBus } from '../ServiceBus.js'
import { UtilityMixin } from '../mixins/UtilityMixin.js'
import VueScrollTable from './reusable/VueScrollTable.vue'
export default {
  name: 'List',
  components: {
    VueScrollTable,
  },
  mixins: [UtilityMixin],
  data() {
    return {
      auth: null,
      prefs: null,
      windowHeight: 0,
      users: [],
      columns: [],
      columnsLogLive: [],
      columnsLogOld: [],
      options: {
        id: 'ZS001',
        isResizeable: true,
        isSelectable: true,
        cssContainer: '',
        cssHeader: 'table_list_header',
        cssBody: 'table_list',
        cssRows: 'table_list',
        order_col: 'nome',
      },
      optionsLogLive: {
        id: 'ZS002',
        isResizeable: true,
        isSelectable: true,
        cssContainer: '',
        cssHeader: 'table_list_header',
        cssBody: 'table_list',
        cssRows: 'table_list',
        order_col: 'date',
      },
      optionsLogOld: {
        id: 'ZS003',
        isResizeable: true,
        isSelectable: true,
        cssContainer: '',
        cssHeader: 'table_list_header',
        cssBody: 'table_list',
        cssRows: 'table_list',
        order_col: 'date',
      },
      updateInterval: null,
      loginLiveOld: [],
      loginLive: [],
      logs: [],
    }
  },
  beforeRouteLeave(to, from, next) {
    const vm = this
    // let myCookie = {
    //   order_col: vm.options.order_col,
    //   columns: vm.wcolumns,
    // }
    // this.$cookie.set(this.options.id, JSON.stringify(myCookie), 365)
    window.removeEventListener('resize', this.getWindowHeight)
    next()
  },
  created() {
    const vm = this
    vm.prefs = JSON.parse(vm.$localStorage.get('prefs'))
    vm.auth = JSON.parse(vm.$localStorage.get('auth'))
  },
  mounted() {
    const vm = this
    vm.api_server = vm.getApiServer()
    vm.initColumns()
    vm.$nextTick(function () {
      window.removeEventListener('resize', null)
      window.addEventListener('resize', this.getWindowHeight)
      vm.doGetUsers()
      vm.doGetLive()
      vm.doGetLogs()
      vm.getWindowHeight()
    })
  },
  methods: {
    initColumns() {
      const vm = this
      vm.columns = [
        {
          id: 'go',
          visible: true,
          mousefeedback: true,
          f_type: '*',
          title: '>',
          alignment_th: 'center_align',
          alignment_td: 'center_align',
          width: 40,
          elastic: false,
          filter: '',
          order: -1,
          image: true,
          image_name: 'images/go.png',
        },
        {
          id: 'cod',
          visible: true,
          f_type: '*',
          title: 'Codice',
          width: 80,
          alignment_th: '',
          alignment_td: '',
          elastic: false,
          filter: '',
          order: 1,
          image: false,
          calcColor: true,
        },
        {
          id: 'nome',
          visible: true,
          f_type: '*',
          title: 'Cliente',
          alignment_th: '',
          alignment_td: '',
          width: 200,
          elastic: true,
          filter: '',
          order: 0,
          image: false,
        },
      ]
      vm.columnsLogLive = [
        {
          id: 'cod',
          visible: true,
          f_type: '*',
          title: 'Codice',
          width: 80,
          alignment_th: '',
          alignment_td: '',
          elastic: false,
          filter: '',
          order: 1,
          image: false,
          calcColor: true,
        },
        {
          id: 'nome',
          visible: true,
          f_type: '*',
          title: 'Cliente',
          alignment_th: '',
          alignment_td: '',
          width: 200,
          elastic: true,
          filter: '',
          order: 0,
          image: false,
        },
        {
          id: 'date',
          visible: true,
          f_type: '*',
          title: 'Data',
          alignment_th: '',
          alignment_td: '',
          width: 200,
          elastic: false,
          filter: '',
          order: 1,
          image: false,
        },
      ]
      vm.columnsLogOld = [
        {
          id: 'cod',
          visible: true,
          f_type: '*',
          title: 'Codice',
          width: 80,
          alignment_th: '',
          alignment_td: '',
          elastic: false,
          filter: '',
          order: 1,
          image: false,
          calcColor: true,
        },
        {
          id: 'nome',
          visible: true,
          f_type: '*',
          title: 'Cliente',
          alignment_th: '',
          alignment_td: '',
          width: 200,
          elastic: true,
          filter: '',
          order: 0,
          image: false,
        },
        {
          id: 'date',
          visible: true,
          f_type: '*',
          title: 'Data',
          alignment_th: '',
          alignment_td: '',
          width: 200,
          elastic: false,
          filter: '',
          order: 1,
          image: false,
        },
        {
          id: 'stato',
          visible: true,
          f_type: '*',
          title: 'Stato',
          alignment_th: '',
          alignment_td: '',
          width: 50,
          elastic: false,
          filter: '',
          order: 0,
          image: false,
        },
      ]
    },
    colClick(id, col, row) {
      if (col.id === 'go') {
        this.$localStorage.set('zap_l', row.login)
        this.$localStorage.set('zap_p', row.password)
        this.$router.push('/login')
      }
    },
    format_cell(value, filter) {
      let res = value
      let dd
      switch (filter) {
        case 'mssg_filter':
          if (!value) res = ''
          res = value.split('[')[0]
          break
        case 'pipe_filter':
          if (!value) res = ''
          res = value.replace(/\|/g, ' ')
          break
        case 'date_reverse_filter':
          if (!value) res = ''
          dd = value.split(' ')
          res = dd[0].split('-').reverse().join('-') + ' ' + dd[1]
          break
      }
      return res
    },
    async doGetLive() {
      const vm = this
      if (vm.auth.tipo == 1) {
        try {
          let date = new Date().toLocaleMysqlString()
          const response = await axios.get(
            vm.api_server + 'login_users/' + date,
            {
              headers: {
                Authorization: vm.auth.tkn,
              },
            }
          )
          if (vm.checkTkn(response.data)) {
            vm.loginLive = response.data
          }
        } catch (e) {
          console.log('error ' + e)
        }
      } else {
        this.$router.push('/')
      }
    },
    async doGetOld() {
      const vm = this
      if (vm.auth.tipo == 1) {
        try {
          let date = new Date().toLocaleMysqlString()
          const response = await axios.get(
            vm.api_server + 'login_users_old/' + date,
            {
              headers: {
                Authorization: vm.auth.tkn,
              },
            }
          )
          if (vm.checkTkn(response.data)) {
            vm.loginLiveOld = response.data
          }
        } catch (e) {
          console.log('error ' + e)
        }
      } else {
        this.$router.push('/')
      }
    },
    async doGetLogs() {
      const vm = this
      if (vm.auth.tipo == 1) {
        try {
          let date = new Date().toLocaleMysqlString()
          const response = await axios.get(vm.api_server + 'get_logs/' + date, {
            headers: {
              Authorization: vm.auth.tkn,
            },
          })
          if (vm.checkTkn(response.data)) {
            vm.logs = response.data
          }
        } catch (e) {
          console.log('error ' + e)
        }
      } else {
        this.$router.push('/')
      }
    },
    async doGetUsers() {
      const vm = this
      if (vm.auth.tipo == 1) {
        try {
          const response = await axios.get(vm.api_server + 'get_users', {
            headers: {
              Authorization: vm.auth.tkn,
            },
          })
          if (vm.checkTkn(response.data)) {
            vm.users = response.data
          }
        } catch (e) {
          console.log('error ' + e)
        }
      } else {
        this.$router.push('/')
      }
    },
    getWindowHeight(event) {
      this.windowHeight = document.documentElement.clientHeight
      document
        .getElementById(this.options.id + 'bw')
        .setAttribute('style', 'height:' + (this.windowHeight - 105) + 'px')
      document
        .getElementById(this.optionsLogLive.id + 'bw')
        .setAttribute('style', 'height:' + (this.windowHeight - 105) + 'px')
      document
        .getElementById(this.optionsLogOld.id + 'bw')
        .setAttribute('style', 'height:' + (this.windowHeight - 105) + 'px')
    },
    beforeDestroy() {
      const vm = this
      window.removeEventListener('resize', vm.getWindowHeight)
    },
  },
}
</script>
